var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text--primary"},[_c('span',{staticClass:"footer-text",domProps:{"innerHTML":_vm._s(_vm.selectedInitiative.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }